import React from "react";
import {FormControl, InputLabel, MenuItem, Select, Typography} from "@mui/material";

export interface OrgUser {
    user_id: string;
    email: string;
    role: string;
    activated?: boolean;
}

interface UserSelectProps {
    label: string;
    value: string;
    users: OrgUser[] | null | undefined;
    onChange: (userUuid: string) => void;
    disabled?: boolean;
    required?: boolean;
    helperText?: string;
}

/**
 * UserSelect renders a single MUI Select showing `{email} — {role}` for every
 * active user in the list. Used by the brand and product editors to let the
 * caller attribute an entity to a specific teammate.
 */
export default function UserSelect(props: UserSelectProps) {
    const {label, value, users, onChange, disabled, required, helperText} = props;

    const activeUsers = (users ?? []).filter((u) => u.activated !== false);

    return (
        <FormControl fullWidth size="small" disabled={disabled} required={required}>
            <InputLabel id="user-select-label">{label}</InputLabel>
            <Select
                labelId="user-select-label"
                label={label}
                value={value || ""}
                onChange={(e) => onChange(String(e.target.value))}
            >
                {activeUsers.map((u) => (
                    <MenuItem key={u.user_id} value={u.user_id}>
                        {u.role ? `${u.email} — ${u.role}` : u.email}
                    </MenuItem>
                ))}
            </Select>
            {helperText && (
                <Typography variant="caption" sx={{mt: 0.5, color: "text.secondary"}}>
                    {helperText}
                </Typography>
            )}
        </FormControl>
    );
}
